import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { FaHome, FaChevronRight } from 'react-icons/fa';

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
  separator?: React.ReactNode;
  showHome?: boolean;
  homeText?: string;
  homePath?: string;
  className?: string;
  linkProps?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
  activeLinkProps?: React.HTMLAttributes<HTMLSpanElement>;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items = [],
  separator = <FaChevronRight className='h-3 w-3 mx-2' />,
  showHome = false,
  homeText = 'Home',
  homePath = '/',
  className = '',
  linkProps = {},
  activeLinkProps = {},
}) => {
  const { orgSlug } = useParams<{ orgSlug: string }>();

  return (
    <nav
      className={`flex items-center text-sm overflow-x-auto whitespace-nowrap scrollbar-hide no-scrollbar ${className}`}
      aria-label='Breadcrumb'
    >
      <ol className='flex items-center h-full min-w-max'>
        {showHome && (
          <li>
            <div className='flex items-center'>
              <Link
                to={homePath}
                className='text-gray-500 hover:text-gray-700 flex items-center'
                {...linkProps}
              >
                <FaHome className='h-3 w-3 mr-1' />
                {homeText}
              </Link>
              {items.length > 0 && separator}
            </div>
          </li>
        )}

        {items.map((item, index) => (
          <li key={index}>
            <div className='flex items-center'>
              {index === items.length - 1 ? (
                <span
                  className='text-neutral-medium font-medium'
                  aria-current='page'
                  {...activeLinkProps}
                >
                  {item.label}
                </span>
              ) : (
                <>
                  <Link
                    to={
                      item.label === 'HRMS' && (item.path === '/dashboard' || item.path.endsWith('/dashboard'))
                        ? `/${orgSlug || 'org'}/hrms/dashboard`
                        : item.path
                    }
                    className='text-gray-500 hover:text-gray-700'
                    {...linkProps}
                  >
                    {item.label}
                  </Link>
                  {separator}
                </>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
